import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-628cc5d7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-10 col-lg-4 p-3 bg-light custom-modal m-auto rounded-3 mt-5" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row pt-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
    /*#__PURE__*/_createElementVNode("h4", null, "Un problème pour enregistrer votre carte VAvantages? 😭")
  ])
], -1))
const _hoisted_3 = { class: "row pt-3" }
const _hoisted_4 = { class: "col m-2 text-start" }
const _hoisted_5 = ["href"]
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<ul class=\"ms-5\" data-v-628cc5d7><li class=\"fw-bold\" data-v-628cc5d7>Votre pseudo</li><li class=\"fw-bold\" data-v-628cc5d7>Votre nom</li><li class=\"fw-bold\" data-v-628cc5d7>Votre prénom</li><li class=\"fw-bold\" data-v-628cc5d7>Votre numéro de carte VAvantages</li></ul><p data-v-628cc5d7> Attendez la validation de votre carte VAvantages avant de procéder au paiement (cliquer sur Passer l&#39;étape)... du moins si vous souhaitez bénéficier de la réduction associée 😉. </p>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "backdrop",
    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["self"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", null, [
            _createTextVNode(" Pas de panique, envoyer un petit e-mail à "),
            _createElementVNode("a", {
              href: _ctx.mailURL()
            }, "overrun@24heures.org", 8, _hoisted_5),
            _createTextVNode(" en indiquant: ")
          ]),
          _hoisted_6
        ])
      ])
    ])
  ]))
}